export const USER_TYPOGRAPHY_STYLES_RESET_MODAL = 'UserTypographyStylesResetModal';
export const USER_COLORS_RESET_MODAL = 'UserColorsResetModal';
export const USER_COLORS_RESET_ALL_CHANGES_MODAL = 'UserColorsResetAllChangesModal';
export const ADD_ECWID_BLOCK_MODAL = 'AddEcwidBlockModal';
export const USER_TYPOGRAPHY_RESET_ALL_CHANGES_MODAL = 'UserTypographyResetAllChangesModal';
export const DEFAULT_NOTIFICATION_MODAL = 'DefaultNotificationModal';
export const PUBLISH_ERROR_MODAL = 'PublishErrorModal';
export const DOMAIN_CONNECTION_MODAL = 'DomainConnectionModal';
export const EDIT_ONLINE_STORE_MODAL = 'EditOnlineStoreModal';
